import PropTypes from 'prop-types';
// @flow

import React from 'react';
import I18n from 'PMT/i18n/I18n';

import { FixedSubmitArea } from 'PMT/components/form';

import AbstractFormComponent from 'components/form/AbstractFormComponent';

export default class RestaurantFormComponent extends AbstractFormComponent {

  componentWillReceiveProps(nextProps) {
    if (!this.props.restaurant.equals(nextProps.restaurant)) {
      // restaurant have changed, we reset the form.
      this.setState(this.getDefaultState(nextProps.restaurant));
    }
  }

  // -- events

  onReset = () => {
    this.setState(this.getDefaultState(this.props.restaurant));
  };

  get restaurant() {
    return this.props.restaurant;
  }

  shouldDisableSubmit(): boolean {
    return false;
  }

  //
  // renderers
  //

  renderKycIcon() {
    return (
      <span
        className="restaurant_edit__kyc_icon"
      >
        *
      </span>
    );
  }

  renderBankIcon() {
    return (
      <span
        className="restaurant_edit__bank_icon"
      >
        *
      </span>
    );
  }

  renderMangoPayIcon() {
    return (
      <span
        className="restaurant_edit__mango_pay_icon"
      >
        *
      </span>
    );
  }

  renderIconsLegend() {
    return (
      <div className="restaurant_edit__icons_legend">
        <div>
          {this.renderMangoPayIcon()}
          <label>MangoPay</label>
        </div>

        <div>
          {this.renderKycIcon()}
          <label>
            {I18n.tr('restaurant_edit.kyc')}
          </label>
        </div>

        <div>
          {this.renderBankIcon()}
          <label>
            {I18n.tr('restaurant_edit.bank')}
          </label>
        </div>
      </div>
    );
  }

  renderButtons() {
    return this.renderFixedButtons();
  }

  render() {
    console.error('This method should be override.');

    return (null);
  }

}



// WEBPACK FOOTER //
// ./scripts/pages/restaurant/edit/components/RestaurantFormComponent.js